import UIDs from "../../../UIDs";

const uid = UIDs.layouts.account;

const ActionTypes = {
    LOGOUT: `${uid}.logout`,
    TRY_LOAD_SESSION: `${uid}.tryLoadSession`   
};

export { ActionTypes };
